<template><!--mobile-->
    <el-dialog width="75%" :visible.sync="dialog_visible" :close-on-click-modal="false" v-mobile-dialog
               :before-close="handleClose" append-to-body class="mobile-address-book">

        <div slot="title">
            <b class="text-info"> 选择标签</b>
        </div>
        <div class="d-flex flex-column h-100">
            <el-tabs :stretch="true" style="height: 100%;" class="d-flex flex-column" v-model="panel_index">
                <el-tab-pane label="选中的标签" class="h-100">
                    <div class="left-panel h-100 d-flex flex-column">
                        <div class="panel-header mb-2">
                            <el-button type="default" plain size="small" class="float-left" @click="clearLabels">
                                <i class="fa fa-times-circle"></i> 清空
                            </el-button>
                        </div>
                        <div class="panel-body flex-grow-1" >
                            <div v-for="item in labelNames" class="address-item" :key="item.id">
                                {{ item.name }}
                                <div class="icon-button"><a href="javascript:void(0);" @click="removeOneLabel(item.id)">
                                        <i class="fa fa-times-circle"></i></a></div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="待选标签" class="h-100">
                    <div class="right-panel h-100 d-flex flex-column">
                        <div class="panel-header">
                            <el-button type="default" plain size="small" class="float-right" @click="addToAddress">
                                <i class="fa fa-arrow-circle-left"></i> 添加
                            </el-button>
                            <el-input size="mini" type="text" placeholder="搜索" v-model="filter"
                                      clearable
                                      style="width: calc(100% - 80px)" @keyup.native="debounced()"></el-input>
                        </div>
                        <div class="panel-body flex-grow-1">
                            <div  style="height: 100%;overflow: auto;">
                                <div v-for="(item,id) in label_list" class="reference-item" :key="id"
                                     @dblclick="addOneLabel(id)" style="border-bottom: 1px solid #eee;">
                                    <div class=""
                                         style="font-size:13px;padding: 2px 0;margin-bottom: 2px;">
                                        <div class="d-flex justify-content-start align-items-center"
                                             style="min-width: 5em;margin-right: 5px;color: #607d8b">
                                            {{ item.name }}
                                        </div>
                                    </div>
                                    <div class="icon-button">
                                        <el-checkbox v-model="item.select"></el-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click.native="handleClose">取 消</el-button>
            <el-button type="primary" @click.native="editSubmit">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "mh-mobile-label-select",
    data() {
        return {
            dialog_visible: this.visible,
            label_list: {},
            filter: '',
            debounced: null,
            panel_index: '0',
            labels:[]
        }
    },
    props: {
        visible: {
            type: Boolean,
            default() {
                return false;
            }
        },
        value: {
            type: Array,
            default() {
                return [];
            }
        },
        list:{
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        labelNames(){
            return this.labels.map(item => {
                return {
                    id:item,
                    name: this.label_list.hasOwnProperty(item) ? (this.label_list[item].name) :(item+'(已删除)')
                };
            });
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                this.dialog_visible = newVal;
                if (newVal) {
                    this.reload();
                    this.tab_index = '0';
                }
            }
        },
        value: {
            handler(newVal) {
                this.labels = [...newVal];
            },
            deep: true
        },
    },
    methods: {
        handleClose() {
            this.filter = '';
            this.labels = [...this.value];
            this.$emit('update:visible', false);
        },
        editSubmit() {
            this.addToAddress();
            this.$emit('input', this.labels);
            this.$emit('update:visible', false);
        },
        addToAddress() {
            for (let x in this.label_list) {
                if (this.label_list[x].select) {
                    this.addOneLabel(x);
                    this.label_list[x].select = false;
                }
            }
            this.panel_index = '0';
        },
        clearLabels() {
            this.labels.splice(0, this.labels.length);
        },
        removeOneLabel(item) {
            const index = this.labels.indexOf(item);
            if (index >= 0) this.labels.splice(index, 1);
        },
        addOneLabel(item) {
            this.label_list[item].select = false;
            if (this.labels.indexOf(item) >= 0) return;
            this.labels.push(item);
        },
        reload(){
            this.$api('Query.Label.List', {data: this.filter, reserve: this.labels}, true).then(res => {
                const list = Object.assign({}, res.data.data);
                for (let x in list) {
                    list[x] = { name:list[x],select:false};
                }
                this.label_list = list;
            });
        }
    },
    mounted() {
        const vm = this;
        this.debounced = this.$debounce(1000, function () {
            vm.reload();
        });
    }
}
</script>

<style lang="scss">
@import "@/common/scss/mobile-address-book.scss";
</style>

